import { useEffect, useState } from "react";
import { ListType } from "../../types/list";
import { getOrganization, getOrganizations } from "../../dataApi/organizations";

export const useAllOrgData = () => {
  const [organizations, setOrganizations] = useState<ListType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setLoading(true);

      const data = await getOrganizations("1");

      if (data && data.length >= 1) {
        data.sort((a: { name: string }, b: { name: string }) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }

      setOrganizations(data);
      setLoading(false);
    })();
  }, []);

  return { organizations, loading };
};

export const useOrgData = (id: string) => {
  const [org, setOrg] = useState<ListType>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      const orgData = await getOrganization(id, "3");

      setOrg(orgData);
      setLoading(false);
    })();
  }, []);

  return { org, loading };
};
